export const CUSTOM_ICON_BUTTON_SIZES = ['sizeExtraSmall', 'sizeSmall', 'sizeMedium', 'sizeLarge'];
